// The Inventory documents — the list, the detail header, and the three Summary reports.

export const INVENTORY_LIST_QUERY = `
  query InventoryList($page: Int, $limit: Int, $search: InventorySearch) {
    inventory(page: $page, limit: $limit, search: $search) {
      nodes {
        id
        materialName
        materialId
        materialRole
        siteId
        siteName
        storageId
        storageName
        backToBackAccountId
        backToBackAccountName
        facilityType
        terminal
        terminalId
        displayUnit
        weightUnit
        totalCertifiedQuantityDeclaration
        totalCertifiedQuantityWorking
        totalCertifiedQuantityTracking
        trackingUnitStatus
        trackingUnitMessage
      }
      pageInfo { total page limit hasNextPage hasPreviousPage isEmpty }
    }
  }
`;

export const INVENTORY_ITEM_QUERY = `
  query InventoryDetailHeader($facilityType: FacilityType!, $facilityId: ID!, $materialId: ID!, $terminalId: ID) {
    inventoryItem(facilityType: $facilityType, facilityId: $facilityId, materialId: $materialId, terminalId: $terminalId) {
      materialName
      materialId
      siteName
      storageName
      backToBackAccountName
      terminal
      displayUnit
      weightUnit
      totalCertifiedQuantityDeclaration
      totalCertifiedQuantityWorking
      totalCertifiedQuantityTracking
      trackingUnitStatus
      trackingUnitMessage
    }
  }
`;

export const MASS_BALANCE_SUMMARY_QUERY = `
  query MassBalance($siteId: ID!, $materialId: ID!, $mbPeriodDetailId: ID!, $terminalId: ID, $fromDate: String, $toDate: String) {
    massBalanceSummary(siteId: $siteId, materialId: $materialId, mbPeriodDetailId: $mbPeriodDetailId, terminalId: $terminalId, fromDate: $fromDate, toDate: $toDate) {
      periodDetail { periodName startDate endDate }
      rows {
        typeOfRawMaterial
        countryOfOrigin
        ghgSavings
        ghgEmissions
        openingBalance
        inboundQty
        allocatedQty
        closingBalance
      }
      totals { openingBalance inboundQty allocatedQty closingBalance }
    }
  }
`;

export const PHYSICAL_RECONCILIATION_QUERY = `
  query Reconciliation($siteId: ID!, $materialId: ID!, $mbPeriodDetailId: ID!, $terminalId: ID, $fromDate: String, $toDate: String) {
    physicalReconciliationSummary(siteId: $siteId, materialId: $materialId, mbPeriodDetailId: $mbPeriodDetailId, terminalId: $terminalId, fromDate: $fromDate, toDate: $toDate) {
      periodDetail { periodName startDate endDate }
      subPeriods {
        subPeriodId
        startDate
        endDate
        availableClosingBalance
        reconciledQuantity
        adjustedClosingBalance
        physicalClosingBalance
        variance
        variancePercentage
        status
      }
      totals {
        availableClosingBalance
        reconciledQuantity
        adjustedClosingBalance
        physicalClosingBalance
      }
    }
  }
`;

export const MATERIAL_MOVEMENT_QUERY = `
  query Movement($siteId: ID!, $materialId: ID!, $mbPeriodDetailId: ID!, $terminalId: ID, $fromDate: String, $toDate: String) {
    materialMovementSummary(siteId: $siteId, materialId: $materialId, mbPeriodDetailId: $mbPeriodDetailId, terminalId: $terminalId, fromDate: $fromDate, toDate: $toDate) {
      isEmpty
      periods { index start end }
      rows {
        movementType
        actionType
        rawMaterialType
        countryOfOrigin
        ghgSavings
        ghgEmissions
        sourceCount
        periodQtyDeclaration
        periodQtyWorking
        periodQtyTracking
        grandTotalDeclaration
        grandTotalWorking
        grandTotalTracking
      }
      detailed {
        movementType
        actionType
        referenceId
        declarationNo
        counterpartyName
        rawMaterialType
        countryOfOrigin
        ghgSavings
        ghgEmissions
        movementDate
        quantityDeclaration
        quantityWorking
        quantityTracking
      }
      trackingUnit
      trackingUnitStatus
    }
  }
`;
